// @flow

import React from "react";
import classNames from "classnames";

import options from "../utils/options";
import Checkbox from "../../checkbox";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./checkbox.scss";

export class CheckboxWidget extends React.Component<SchemaTableWidgetProps<boolean>> {
  handleChange = (e: SyntheticEvent<HTMLInputElement>): void => {
    this.props.onChange(e.currentTarget.checked);
  };

  render() {
    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    return (
      <div
        className={classNames("checkbox__container", {
          "checkbox__container--disabled": disabled,
        })}
      >
        <Checkbox
          id={`schema-table__checkbox-widget--${this.props.id}`}
          label={this.props.title}
          className="checkbox__input"
          disabled={!this.props.active || disabled}
          checked={this.props.data}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default CheckboxWidget;
